<template>
	<v-container grid-list-md>
		<v-layout row wrap>
			<v-flex xs12 md8>
				<v-layout row wrap>
					<v-flex xs6 md6>
						<ValidationProvider
							name="first_name"
							rules="required"
							v-slot="{ errors }"
						>
							<v-text-field
								:label="$t('First Name')"
								type="text"
								v-model="item.first_name"
								data-vv-name="first_name"
								:error-messages="errors"
							></v-text-field>
						</ValidationProvider>
					</v-flex>
					<v-flex xs6 md6>
						<ValidationProvider
							name="last_name"
							rules="required"
							v-slot="{ errors }"
						>
							<v-text-field
								:label="$t('Last Name')"
								type="text"
								v-model="item.last_name"
								data-vv-name="last_name"
								:error-messages="errors"
							></v-text-field>
						</ValidationProvider>
					</v-flex>
					<v-flex xs6 md6>
						<ValidationProvider name="code" v-slot="{ errors }">
							<v-text-field
								:label="$t('Code')"
								type="text"
								v-model="item.code"
								data-vv-name="code"
								:error-messages="errors"
							></v-text-field>
						</ValidationProvider>
					</v-flex>
					<v-flex xs6 md6>
						<ValidationProvider name="phone" v-slot="{ errors }">
							<v-text-field
								:label="$t('Phone')"
								type="number"
								v-model="item.phone"
								data-vv-name="phone"
								:error-messages="errors"
							></v-text-field>
						</ValidationProvider>
					</v-flex>
					<v-flex xs12 md12>
						<ValidationProvider
							name="description"
							v-slot="{ errors }"
						>
							<v-textarea
								:label="$t('Description')"
								type="text"
								v-model="item.description"
								data-vv-name="description"
								:error-messages="errors"
							></v-textarea>
						</ValidationProvider>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs12 md4 class="pl-8">
				<v-card>
					<v-card-title primary-title>
						<h3>{{ $t("label.cover_image") }}</h3>
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text>
						<app-media-library
							v-model="item.image"
						></app-media-library>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>
		<v-subheader
			><strong>{{ $t("Status") }}</strong>
		</v-subheader>
		<v-layout row wrap>
			<v-flex xs12>
				<v-btn-toggle
					v-model="item.status"
					borderless
					active-class="white--text"
					:readonly="item.readonly"
				>
					<v-btn value="assign" color="light-blue darken-1" dark>
						<v-icon
							left
							v-if="item.status == 'assign'"
							dark
							color="white"
							>mdi-check</v-icon
						>
						<span>Assign</span>
					</v-btn>

					<v-btn value="on_duty" color="teal darken-4" dark>
						<v-icon
							left
							v-if="item.status == 'on_duty'"
							dark
							color="white"
							>mdi-check</v-icon
						>
						<span>on_duty</span>
					</v-btn>

					<v-btn value="available" color="orange darken-3" dark>
						<v-icon
							left
							v-if="item.status == 'available'"
							dark
							color="white"
							>mdi-check</v-icon
						>
						<span>available</span>
					</v-btn>

					<v-btn value="day_off" color="red darken-3" dark>
						<v-icon
							left
							v-if="item.status == 'day_off'"
							dark
							color="white"
							>mdi-check</v-icon
						>
						<span>day_off</span>
					</v-btn>
				</v-btn-toggle>
			</v-flex>
		</v-layout>
		<v-layout
			row
			wrap
			v-if="item.status == 'confirmed' || item.status == 'completed'"
			class="mt-4"
		>
			<v-flex xs12>
				<v-autocomplete
					v-model="item.table_id"
					:items="tables"
					item-value="id"
					item-text="name"
					label="Assign Table"
				></v-autocomplete>
			</v-flex>
		</v-layout>
	</v-container>
</template>
<script>
export default {
	props: ["value", "tables"],
	data() {
		return {};
	},
	computed: {
		item: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit("input", value);
			},
		},
	},
};
</script>